import React from 'react';

export const PROFILE_TABS = Object.freeze({ PROFILE: 'profile', TEAM: 'team' });

/**
 * The two sub-screens of the profile page: Profile and Team Structure.
 *
 * @param {{ active: string, onChange: (tab: string) => void, teamDisabled?: boolean, teamHint?: string }} props
 */
const ProfileTabs = ({ active, onChange, teamDisabled = false, teamHint }) => (
    <div className="prof-tabs" role="tablist" aria-label="Profile sections">
        <button
            type="button"
            role="tab"
            id="prof-tab-profile"
            aria-selected={active === PROFILE_TABS.PROFILE}
            aria-controls="prof-panel"
            className={`prof-tab${active === PROFILE_TABS.PROFILE ? ' active' : ''}`}
            onClick={() => onChange(PROFILE_TABS.PROFILE)}
        >
            Profile
        </button>
        <button
            type="button"
            role="tab"
            id="prof-tab-team"
            aria-selected={active === PROFILE_TABS.TEAM}
            aria-controls="prof-panel"
            className={`prof-tab${active === PROFILE_TABS.TEAM ? ' active' : ''}`}
            onClick={() => onChange(PROFILE_TABS.TEAM)}
            disabled={teamDisabled}
            title={teamDisabled ? teamHint : undefined}
        >
            Team Structure
        </button>
    </div>
);

export default ProfileTabs;
